import { Banner } from './components/Banner';
import { Footer } from './components/Footer';

export const Home = () => {
  return (
    <div className="home-page">
      <Banner />
      <Footer />
    </div>
  );
};
